import { render, staticRenderFns } from "./EDadosDoPagador.vue?vue&type=template&id=a842c4f6"
import script from "./EDadosDoPagador.vue?vue&type=script&lang=js"
export * from "./EDadosDoPagador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports